import React, { useState } from "react";
import { Divider, Typography, CircularProgress } from "@material-ui/core";
import { Pagination } from "@material-ui/lab";
import moment from "moment";
import { useQuery } from "@apollo/react-hooks";
import gql from "graphql-tag";

import Table from "../../components/Table";
import { Card, CardContent, CardActions } from "../../components/Card";
import Grid from "../../components/Grid";
import Button from "../../components/Button";
import { Select, TextInput, DateInput } from "../../components/Form";
import { useAlert } from "../../components/Alert";
import divisions from "../../divisions.json";
const GET_USERS = gql`
  query users(
    $searchTerm: String
    $latest: Boolean
    $identity: Identity
    $pageSize: Int
    $page: Int
  ) {
    users(
      searchTerm: $searchTerm
      latest: $latest
      identity: $identity
      pageSize: $pageSize
      page: $page
    ) {
      count
      pageCount
      contents {
        id
        fullName
        mobile
        address {
          division
          subdivision
          address
        }
        branch
        department
        position
      }
    }
  }
`;
export default function HRmanageTable({ onChangeSelect = () => {} }) {
  const Alert = useAlert();
  const [newData, setNewData] = useState({
    data: [],
    open: false,
    searchTerm: "",
    latestArray: [
      {
        label: "在職員工",
        value: "在職員工",
      },
      {
        label: "離職員工",
        value: "離職員工",
      },
      {
        label: "加盟店",
        value: "加盟店",
      },
    ],
    latestObject: {
      label: "",
      value: "",
    },
    page: 1,
    pageMax: null,
    pageSize: 10,
    pageArray: [],
  });
  const { data, loading } = useQuery(GET_USERS, {
    fetchPolicy: "network-only",
    notifyOnNetworkStatusChange: true,
    variables: {
      searchTerm: newData.searchTerm,
      latest: true,
      identity: "STAFF",
      pageSize: 10,
      page: newData.page,
    },
    onError(error) {
      return Alert.notice(error.message.replace("GraphQL error: ", ""));
    },
  });
  function changeDataListener(key, v) {}
  function changeData(key, v, rerender = false) {
    if (rerender) setNewData((prev) => ({ ...prev, [key]: v }));
    else setNewData((prev) => Object.assign(prev, { [key]: v }));
    if (typeof changeDataListener === "function") changeDataListener(key, v);
  }
  function getAddress(division, subdivision, address) {
    if (Boolean(division) && Boolean(subdivision)) {
      return (
        divisions[division]["zhTW"] +
        divisions[division]["subdivisions"][subdivision]["zhTW"] +
        address
      );
    } else {
      return null;
    }
  }
  if (loading) {
    return (
      <Grid container item justify="center">
        <CircularProgress color="secondary" />
      </Grid>
    );
  } else {
    return (
      <Card>
        <CardContent>
          <Grid container spacing={1} item>
            {/* <Grid item xs={12} sm={2}>
              <Select
                items={newData.latestArray}
                label={"選擇員工狀態"}
                value={newData.latestObject ? newData.latestObject : null}
                onChange={(e, value) => {
                  if (value) {
                    changeData("latestObject", value, true);
                  } else {
                    changeData("latestObject", { label: "", value: "" }, true);
                  }
                }}
                fullWidth
              />
            </Grid> */}
            <Grid item xs={8} sm={2}>
              <TextInput
                label="輸入姓名"
                value={newData.searchTerm}
                onChange={(v) => changeData("searchTerm", v, true)}
                fullWidth
              />
            </Grid>
            <Grid item xs={6} sm={1}>
              <Button
                color="primary"
                variant="contained"
                onPress={() => onChangeSelect()}
                fullWidth
              >
                新增
              </Button>
            </Grid>
          </Grid>
        </CardContent>
        <Divider />
        <CardContent>
          <Table
            data={data?.users.contents}
            tableWidth={2}
            header={["姓名", "電話", "地址", "分店", "部門", "職稱"]}
            columns={[
              "fullName",
              "mobile",
              (item) =>
                getAddress(
                  item.address?.division,
                  item.address?.subdivision,
                  item.address?.address
                ),
              "branch",
              "department",
              "position",
            ]}
            onPress={(item) => {
              onChangeSelect(item);
            }}
          />
        </CardContent>
        <CardActions>
          <Grid container justifyContent="center">
            <Pagination
              count={
                Boolean(data) && data.users.pageCount ? data.users.pageCount : 1
              }
              size="large"
              color="primary"
              page={newData.page}
              onChange={(e, n) => {
                changeData("page", n, true);
              }}
            />
          </Grid>
        </CardActions>
      </Card>
    );
  }
}
